module.exports = __webpack_public_path__ + "static/media/InstrumentSans-Medium.9f192f4c.woff2";